import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Uygulama içi gezinmede (ilk yükleme hariç) odak yeni sayfanın başlığına (`[data-page-title]`, yoksa `main`) taşınır:
 * ekran okuyucu yeni sayfayı duyurur, klavye kullanıcısı içerikten devam eder. İlk yüklemede odak belgenin başında kalır
 * (Tab → "İçeriğe geç"). Kabuklar arası geçişte de (giriş → genel bakış, çıkış → giriş) çalışsın diye App düzeyindedir.
 */
export function RouteFocus() {
  const { pathname } = useLocation();
  const first = useRef(true);
  useEffect(() => {
    if (first.current) {
      first.current = false;
      return;
    }
    let observer: MutationObserver | undefined;
    const raf = window.requestAnimationFrame(() => {
      const heading = document.querySelector<HTMLElement>('main [data-page-title]');
      const main = document.getElementById('main-content');
      (heading ?? main)?.focus();
      if (heading || !main) return;

      // Tembel yüklenen sayfanın başlığı henüz yoksa montajını bekle. Kullanıcı
      // bu sırada başka bir öğeye geçtiyse odağı geri çalma.
      observer = new MutationObserver(() => {
        const title = main.querySelector<HTMLElement>('[data-page-title]');
        if (!title) return;
        if (document.activeElement === main) title.focus();
        observer?.disconnect();
      });
      observer.observe(main, { childList: true, subtree: true });
    });
    return () => {
      window.cancelAnimationFrame(raf);
      observer?.disconnect();
    };
  }, [pathname]);
  return null;
}
